import { styled, css } from "styled-components";

export const FlexBox = styled.div<{
  $gap?: number;
  $flexWrap?: string;
  $justifyContent?: string;
  $autoMaxWidth?: boolean;
  $alignItems?: string;
  $width?: string;
  $flexDirection?: string;
  $padding?: {
    vertical: number;
    horizontal: number;
  };
}>`
  display: flex;
  flex-wrap: ${({ $flexWrap }) => $flexWrap};
  justify-content: ${({ $justifyContent }) => $justifyContent};
  align-items: ${({ $alignItems }) => $alignItems};
  gap: ${({ $gap }) => $gap}px;
  width: ${({ $width, $flexDirection }) =>
          $flexDirection === "row" ? $width : ""};
  height: ${({ $width, $flexDirection }) =>
          $flexDirection === "column" ? $width : ""};
  flex-direction: ${({ $flexDirection }) => $flexDirection};
  ${({ $padding }) =>
          $padding &&
          css`
      padding: ${$padding.vertical}px ${$padding.horizontal}px;
    `}
  ${({ $autoMaxWidth, theme }) =>
          $autoMaxWidth
                  ? css`
          max-width: ${theme.content.maxWidth}px;
          margin: 0 auto;
        `
                  : css`
          max-width: 100%;
        `}
    > div > div {
    display: flex;
    flex-wrap: ${({ $flexWrap }) => $flexWrap};
    justify-content: ${({ $justifyContent }) => $justifyContent};
    align-items: ${({ $alignItems }) => $alignItems};
    gap: ${({ $gap }) => $gap}px;
    width: ${({ $width, $flexDirection }) =>
            $flexDirection === "row" ? $width : ""};
    height: ${({ $width, $flexDirection }) =>
            $flexDirection === "column" ? $width : ""};
    flex-direction: ${({ $flexDirection }) => $flexDirection};
    ${({ $padding }) =>
            $padding &&
            css`
        padding: ${$padding.vertical}px ${$padding.horizontal}px;
      `}
    ${({ $autoMaxWidth, theme }) =>
            $autoMaxWidth
                    ? css`
            max-width: ${theme.content.maxWidth}px;
            margin: 0 auto;
          `
                    : css`
            max-width: 100%;
          `}
  }
`;
